import { cn } from '@/app/utils'

import { useExpandableText } from '../hooks/use-expandable-text'

interface IExpandableTextProps {
  text: string
  maxLines?: number
  className?: string
  buttonClassName?: string
}

const ExpandableText = ({
  text,
  maxLines = 2,
  className = '',
  buttonClassName = ''
}: IExpandableTextProps) => {
  const { isExpanded, needsTruncation, textRef, toggleExpand } =
    useExpandableText(text, maxLines)

  return (
    <div className={cn('relative', className)}>
      <p
        ref={textRef}
        className={cn(
          'text-grey-90',
          'text-18',
          'sm:text-16',
          'break-words',
          !isExpanded && needsTruncation ? `line-clamp-${maxLines} pr-24` : ''
        )}
      >
        {text}
        {!isExpanded && needsTruncation && (
          <button
            type="button"
            className={cn(
              'absolute',
              'bottom-0',
              'right-0',
              'cursor-pointer',
              'bg-grey-10',
              'pl-1',
              'text-bronze-40',
              'hover:underline',
              buttonClassName
            )}
            onClick={toggleExpand}
          >
            ещё
          </button>
        )}
        {isExpanded && (
          <button
            type="button"
            className={cn(
              'cursor-pointer',
              'pl-8',
              'text-bronze-40',
              'hover:underline',
              buttonClassName
            )}
            onClick={toggleExpand}
          >
            свернуть
          </button>
        )}
      </p>
    </div>
  )
}
export default ExpandableText
